module.exports = __webpack_public_path__ + "img/2-center.89580ed8.svg";